import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";

import FormLineChartPanel from "./FormLineChartPanel";
import NewLine from "../../component/chart/NewLine";
import LoadingContent from "../../component/loading/LoadingContent";
import actions from "../../redux/actions";

const Section = styled.section`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  & > * {
    width: 100%;
  }

  .container {
    margin-top: 20px;
  }
`;

export default function LineChart(props) {
  const [content, setContent] = useState(false);
  const graphData = useSelector((state) => state.stations.graphData);
  const rendering = useSelector((state) => state.stations.rendering);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [formSearch, setFormSearch] = useState(null);

  function toggleVisible(name, value) {
    dispatch(actions.Stations.setVisible({ name, visible: value }));
  }

  useEffect(() => {}, [graphData, formSearch]);

  return (
    <Section
      className={
        "section-station__graph" + (props.className ? props.className : "")
      }
    >
      <FormLineChartPanel
        fncSetContent={setContent}
        setLoading={setLoading}
        stationId={parseInt(props.stationId)}
        sensorId={props.sensorId}
        setFormSearch={setFormSearch}
      />
      <div className="container">
        {!content ? (
          <LoadingContent />
        ) : (
          <>
            <NewLine
              formSearch={formSearch}
              key={props.sensorId}
              title={props.sensorDispName}
              subtitles={[
                {
                  text: formSearch
                    ? formSearch?.offset
                      ? "ค่าระดับน้ำที่หักค่าเกณฑ์หักน้ำแล้ว"
                      : "ค่าระดับน้ำวัดเทียบจากศูนย์บรรทัดน้ำ"
                    : "",
                  verticalAlign: "top",
                  horizontalAlign: "left",
                  fontWeight: "bold",
                },
              ]}
              data={graphData}
              toggleVisible={toggleVisible}
              rendering={rendering}
              loading={loading}
            />
          </>
        )}
      </div>
    </Section>
  );
}
